import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { useTheme } from '@mui/material';
import { useAuthContext, useToggle } from '../../hooks';
import { Person } from '@mui/icons-material';
import { GatewaysModal } from '../GatewaysModal';

const pages = ['Products', 'Pricing', 'Blog'];
const settings = ['Logout'];

export function Layout({children}: React.PropsWithChildren) {
  const theme = useTheme()
  const [editGatewaysModalVisibility, editGatewaysModalVisibilityControls] = useToggle(false)
  const {signOut} = useAuthContext()
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <Box sx={{
        height: '100vh'
    }}>
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
            <img src="/assets/logo-white.png" width={200} alt="Milespay Logo" /> 
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            <Button
              href='/'
              sx={{ my: 2, color: 'white', display: 'block' }}
            >
              Pedidos
            </Button>
            <Button
              onClick={editGatewaysModalVisibilityControls.setTrue}
              sx={{ my: 2, color: 'white', display: 'block' }}
            >
              Gateways
            </Button>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar>
                  <Person />
                </Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem onClick={signOut}>
                <Typography sx={{ textAlign: 'center' }}>Logout</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
    <Box
        sx={{
            backgroundColor: 'rgb(59 99 129 / 50%)',
            display: 'flex',
            justifyContent: 'center',
            paddingTop: 2,
            height: 'calc(100vh - 64px)'
        }}
    >
        {children}
    </Box>
      {editGatewaysModalVisibility && <GatewaysModal onClose={editGatewaysModalVisibilityControls.setFalse} onSuccess={editGatewaysModalVisibilityControls.setFalse} />}
    </Box>
  )
}
